import Question from "./question.js"
import DrawingQuestionComponent from "../components/questions/drawing-question.js"
import DrawingReportComponent from "../components/reports/drawing-report.jsx";

class DrawingQuestion extends Question {
  component(mode) {
    if(mode == "student-facing-report") {
      return DrawingReportComponent;
    }
    return DrawingQuestionComponent;
  }
}

export default DrawingQuestion